'use strict';
var Helper = require('od-modules/helpers/helper');
var PassengersCollection = require('od-modules/collections/passengers.collection');
var SeatMapPreferencesSelection = require('od-modules/collections/seatmap_preferences_selections.collection');
var SeatMapDescriptors = require('od-modules/collections/seatmap_descriptors.collection');
const ShoppingCart = require('od-modules/cart/cart');

module.exports = new Helper({
    CollectionClass: SeatMapDescriptors,
    viewClass: null,
    exposedMethods: null,
    seatMapSelectionCollection: null,
    passengerCollection: null,
    seatMapDescriptorCollection: null,
    preSelectedSeats: null,
    init: function() {
        if (this.isPostBookingAircraftMap() || this.isPassengersPageAircraftMap()) {
            this.passengerCollection = PassengersCollection.getInstance();
            this.seatMapSelectionCollection = SeatMapPreferencesSelection.getInstance();
            this.seatMapDescriptorCollection = new this.CollectionClass(null);
            this.setUpView();
            this.bindEvents();
            this.updateShoppingCart();
        }
    },
    bindEvents: function() {
        this.listenTo(this.seatMapSelectionCollection, 'seatMapSelectionResponseIsOK', this.updateView, this);
        this.listenTo(this.seatMapSelectionCollection, 'add', this.updateView, this);
        this.listenTo(this.seatMapSelectionCollection, 'remove', this.updateView, this);
        this.listenTo(this.seatMapSelectionCollection, 'reset', this.updateView, this);
    },
    addSelection: function(seat) {
        this.seatMapSelectionCollection.addSelection(seat);
    },
    removeSelection: function(selection) {
        this.seatMapSelectionCollection.removeSelection(selection);
    },
    removeAllSelection: function() {
        this.seatMapSelectionCollection.resetCollection();
    },
    getTrackingConfig: function() {
        return {
            type: 'trackEvent',
            data: {
                category: this.getTrackingCategory(),
                action: 'seat_selection',
            },
        };
    },
    getTrackingCategory: function() {
        return this.isPostBookingAircraftMap() ? 'my_area_trips_details' : 'flights_pax_page';
    },
    isPostBookingAircraftMap: function() {
        return (
            (this.id === 'post-booking-aircraftmap' ||
            this.id === 'aircraft-desktop' ||
            this.id === 'aircraftmap-checkin' ||
            this.id === 'aircraftmap-checkin-mobile') &&
            (Odigeo.History.getPageNameFromFragment() === 'post_booking' ||
            Odigeo.History.getPageNameFromFragment() === 'mytrips' ||
            Odigeo.History.getPageNameFromFragment() === 'tripdetails' ||
            Odigeo.History.getPageFragment().includes('checkin-funnel'))
        );
    },
    isPassengersPageAircraftMap: function() {
        return (this.id === 'aircraft_map' && Odigeo.History.getPageNameFromFragment() === 'passengersinfo')
            || (this.id === 'aircraft_map_manager' && Odigeo.History.getPageNameFromFragment() === 'details');
    },
    openAircraftMapSetup: function(seatMap, aircraftOptions) {
        const seat = !Odigeo._.isEmpty(seatMap) ? this.returnSeatsFromCabins(seatMap.cabin) : {};
        Odigeo._.extend(this.options, aircraftOptions);
        this.seatMapDescriptorCollection.fillData(seat, aircraftOptions.segment, aircraftOptions.section);
    },
    returnSeatsFromCabins: function(cabins) {
        return Odigeo._.reduce(cabins, function(memo, cabin) {
            return memo.concat(cabin.seats.seat);
        }, []);
    },
    allPaxHaveSeatInSection: function(segment, section) {
        return Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(section)) === this.options.nEligibleTravellers;
    },
    updateView: function() {
        this.updateShoppingCart();
        this.render();
    },
    updateShoppingCart() {
        const {length = 0} = this.seatMapSelectionCollection || {};

        const _fee = this.seatMapSelectionCollection.getSeatSelectionFees();
        const primeFee = this.seatMapSelectionCollection.getSeatSelectionPrimeFees();

        const isSeatsPrimeDiscounts = Odigeo.AB.isSeatsPrimeDiscountsMobile;
        const totalPrimePrice = isSeatsPrimeDiscounts ? this.seatMapSelectionCollection.getSelectedSeatsPrimePrice() : 0;
        const usePrimePrice = totalPrimePrice > 0 || (isSeatsPrimeDiscounts && length === 0);

        let total = this.seatMapSelectionCollection.getTotalPrice();
        let fee = _fee;
        let primePerks = 0;
        let primePerksFromDapi = 0;

        if (usePrimePrice) {
            const isPriceWithDiscountSelected = Odigeo.Membership.isPriceWithoutDiscountSelected === 'false';

            primePerks = total - totalPrimePrice;
            primePerksFromDapi = this.seatMapSelectionCollection.getPerksFromDapi();
            total = totalPrimePrice;

            if (isPriceWithDiscountSelected) {
                fee = primeFee;
            }
        }

        ShoppingCart.builders.seat.data({
            usePrimePrice,
            price: {
                total,
                fee,
            },
            perks: {
                fromClient: primePerks,
                fromDapi: primePerksFromDapi,
            },
            selection: this.seatMapSelectionCollection,
            quantity: length,
        }).fromWidget().add();
    },
    analyticsEventTracking: function(label) {
        const clonedDataTracking = $.extend(true, {}, this.getTrackingConfig());
        Odigeo._.extend(clonedDataTracking.data, label);
        Odigeo.trigger('analytics:tracking', clonedDataTracking);
        return this;
    },
});
